import { createApi } from "@reduxjs/toolkit/query/react";
import {
  baseQueryWithArgs,
  getQueryStringWithCreator,
} from "../utils/reduxHelper";

export const miniSourcingAuthAPI = createApi({
  reducerPath: "miniSourcingAuthAPI",
  baseQuery: baseQueryWithArgs,
  refetchOnFocus: true,
  endpoints: (builder) => ({
    checkMiniSourcing: builder.query({
      refetchOnFocus: true,
      query: () => getQueryStringWithCreator(`s/checkIsMiniSourcingAlive`),
      transformResponse: (response) => {
        if (response?.success) {
          return response;
        }
        return undefined;
      },
    }),
    getCreatorFreshdeskConversation: builder.query({
      query: () => ({
        url: `/c/getCreatorFreshdeskConversationStatus`,
        method: "GET",
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useCheckMiniSourcingQuery,
  useGetCreatorFreshdeskConversationQuery,
} = miniSourcingAuthAPI;

export default miniSourcingAuthAPI;
